<template>
  <div class="histogram">
    <div
      class="text-box-left"
      v-if="position === 'right'"
      :style="{ width: textWidth + 'vw' }"
    >
      <!-- {{ isTime ? root_timeToMinute(percentage) : percentage }} -->
      <!-- {{ percentage }} -->
      <NumberScrolling :tarVal="value" :unit="suffix"></NumberScrolling>
    </div>
    <div
      class="color-line-box"
      :style="{
        width: 'calc(100% - 0.32vw - ' + textWidth + 'vw)',
        height: barHeight + 'vw',
      }"
    >
      <AbColorLine
        :position="position"
        :mainColor="mainColor"
        :backgroundColor="backgroundColor"
        :maxValue="maxValue"
        :value="value"
        :barHeight="barHeight"
      ></AbColorLine>
    </div>
    <div
      class="text-box-right"
      v-if="position === 'left'"
      :style="{ width: textWidth + 'vw' }"
    >
      <!-- {{ isTime ? root_timeToMinute(percentage) : percentage }} -->
      <!-- {{ percentage }} -->
      <NumberScrolling :tarVal="value" :unit="suffix"></NumberScrolling>
    </div>
  </div>
</template>

<script>
// 柱状图，包含数字
import AbColorLine from './AbColorLine'
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
export default {
  props: {
    // 必传参数，柱状图的数值
    value: {
      default: 0,
    },
    // 必传参数，柱状图的数值占用的宽度
    textWidth: {
      type: Number,
      default: 18,
    },
    // 必传参数，带颜色的横条所在位置，只会left、right
    position: {
      type: String,
      default: '',
    },
    // 必传参数，柱状图主颜色
    mainColor: {
      type: String,
      default: '#C23531',
    },
    // 非必传参数（目前UI图所有颜色都一样），柱状图底部100%的颜色
    backgroundColor: {
      type: String,
      default: '#EAEDF1',
    },
    // 必传参数，当前项的最大值，用于计算当前项所占百分比
    maxValue: {
      default: 100,
    },
    // 必传参数，当前柱状图高度
    barHeight: {
      type: Number,
      default: 0,
    },
    // 计算参数 用来判断是否进入百分比计算显示文字的条件
    textValue: {
      type: String,
    },
    suffix: {
      // 单位
      type: String,
      default: '',
    },
    isTime: {
      // 时间
      default: false,
    },
  },
  data() {
    return {
      precentageValue: '', // 百分比数值
    }
  },
  computed: {
    percentage() {
      if (this.suffix) {
        return this.value + this.suffix
      } else {
        return this.value
      }
    },
  },
  components: {
    AbColorLine,
    NumberScrolling,
  },
}
</script>

<style lang="scss" scoped>
.histogram {
  height: auto;
}
.text-box-left {
  display: inline-block;
  font-size: 0.833vw;
  color: var(--mixtmt_greyColor2);
  margin-right: 0.32vw;
  vertical-align: middle;
  text-align: right;
}
.text-box-right {
  font-size: 0.833vw;
  color: var(--mixtmt_greyColor2);
  margin-left: 0.32vw;
  display: inline-block;
  vertical-align: middle;
}
.color-line-box {
  display: inline-block;
  vertical-align: middle;
}
</style>
